import React from 'react';
import CADDashboardFixed from './CAD_Dashboard_MapFixed';

function App() {
  return <CADDashboardFixed />;
}

export default App;
